/** @format */

import { Paper, Grid, Typography, Backdrop, CircularProgress } from '@mui/material';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@mui/styles';
import { Icons } from 'components';

// TODO: add this component to ~/components folder to use globaly

export default function UploadDoc({ acceptsFile, file, setFile, disabled, onHandleChange }) {
  // --STAETS--//

  // --SERVICES--//

  // --OTHER FUNCTIONS--//
  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
    onHandleChange(acceptedFiles[0])
  }, []);

  // --HOOKS--//
  const classes = useStyles();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Paper className={classes.uploadPaper} elevation={0}>
      <Backdrop open={disabled} className={classes.backdrop} />
      <div {...getRootProps()}>
        <input
          {...getInputProps()}
          multiple={false}
          //accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          //accept="image/jpeg,image/jpg,image/png,application/pdf"
          accept={acceptsFile}
          disabled={disabled}
        />
        <Grid justifyContent="center" container direction="column" item xs={12} style={disabled ? { visibility: 'hidden' } : {}}>
          <Grid justifyContent="center" container item xs={12}>
            {file ? (
              <Typography className={classes.fileFormat} variant="h5" align="center">
                {`.${file?.name?.split('.').pop()}`}
              </Typography>
            ) : isDragActive ? (
              <span className={classes.dragHereIcon}>
                <Icons icon="plusCircle" color="#2B3990" size="20" />
              </span>
            ) : (
              <span className={classes.dragHereIcon}>
                <Icons icon="NoteAdd" color="#2B3990" size="20" />
              </span>
            )}
          </Grid>
          <Grid justifyContent="center" container item xs={12}>
            <Typography className={classes.dragHereText} variant="h5" align="center">
              {file
                ? file?.name
                : isDragActive
                  ? 'فایل را اینجا رها کنید'
                  : 'فایل  را به اینجا بکشید یا انتخاب کنید'}
            </Typography>
          </Grid>
        </Grid>
      </div>
      {
        disabled &&
        <div style={{ position: 'absolute', width: '100%', height: '100%', top: '0', right: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress size={28} className={classes.buttonProgress} />
        </div>
      }
    </Paper>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    uploadPaper: {
      position: 'relative',
      //marginInlineStart: '8px',
      background: theme.palette.grey[100],
      border: `1px dotted ${theme.palette.primary.light}`,
      padding: theme.spacing(4),
      boxSizing: 'border-box',
      borderRadius: 10,
      cursor: 'pointer',
      transform: 'scale(1)',
      width: '100%',
      //marginInlineEnd: theme.spacing(1),
      overflow: 'hidden',
      transition: 'ease .2s transform,ease .2s border',
      '&:hover': {
        borderColor: theme.palette.grey[700],
      },
      '&:active': {
        transform: 'scale(.98)',
      },
      '& *': {
        outline: 'none',
      },
    },
    dragHereIcon: {
      fontSize: 50,
      color: theme.palette.grey[600],
    },
    dragHereText: {
      paddingTop: theme.spacing(2),
      color: theme.palette.grey[600],
      fontFamily: 'Vazir',
    },
    fileFormat: {
      direction: 'rtl',
      fontSize: 40,
      marginBottom: 13,
      marginTop: 13,
      color: theme.palette.grey[600],
    },
    backdrop: {
      //opacity: '0.1 !important',
      background: theme.palette.grey[100],
    },
  };
});


